import {
  ForwardRefExoticComponent,
  ReactSVG,
  RefAttributes,
  SVGProps,
  createElement,
  forwardRef,
} from "react";
import defaultAttributes from "./defaultAttributes";

export type IconNode = [
  elementName: keyof ReactSVG,
  attrs: Record<string, string>
][];

export type SVGAttributes = Partial<SVGProps<SVGSVGElement>>;
type ComponentAttributes = RefAttributes<SVGSVGElement> & SVGAttributes;

export interface GoogleMaterialProps extends ComponentAttributes {
  size?: string | number;
  absoluteStrokeWidth?: boolean;
}

export type GoogleMaterialIcon = ForwardRefExoticComponent<GoogleMaterialProps>;
/**
 * Converts string to KebabCase
 * Copied from scripts/helper. If anyone knows how to properly import it here
 * then please fix it.
 *
 * @param {string} string
 * @returns {string} A kebabized string
 */
export const toKebabCase = (string: string) =>
  string
    .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
    .toLowerCase()
    .trim();

const createIcon = (iconName: string, iconNode: IconNode): GoogleMaterialIcon => {
  const Component = forwardRef<SVGSVGElement, GoogleMaterialProps>(
    (
      {
        color = "currentColor",
        size = 24,
        strokeWidth = 2,
        absoluteStrokeWidth,
        className = "",

        children,
        ...rest
      },
      ref
    ) => {
      return createElement(
        "svg",
        {
          ref,
          ...defaultAttributes,
          width: size,
          height: size,

          className: [className].join(" "),
          ...rest,
        },
        [
          ...iconNode.map(([tag, attrs]) => createElement(tag, attrs)),
          ...(Array.isArray(children) ? children : [children]),
        ]
      );
    }
  );

  Component.displayName = `${iconName}`;

  return Component;
};

export default createIcon;
